module.exports = __webpack_public_path__ + "static/29invgde-3e0658fe8fe34615bf7a440a78941d58.gif";